import { useEffect, useRef, useState } from 'react';
import './index.scss';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import clsx from 'clsx';

type TProps = {
  selectedValue: string;
  onChange: (val: string) => void;
  options: TOption[];
  label: string;
  selectIcon?: string;
};

export type TOption = {
  value: string;
  label: string;
  icon?: React.JSX.Element;
};

export function AppSelect({
  selectedValue,
  onChange,
  options,
  label,
  selectIcon,
}: TProps) {
  const [open, setOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);

  const handleOptionSelection = (option: TOption) => {
    onChange(option.value);
    setOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      selectRef.current &&
      !selectRef.current.contains(event.target as Node)
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    open &&
      document.addEventListener(
        'click',
        handleClickOutside
      );
    return () => {
      document.removeEventListener(
        'click',
        handleClickOutside
      );
    };
  }, [open]);

  const selectedOption = options.find(
    (option) => option.value === selectedValue
  );
  const displayLabel = selectedOption?.label || selectedValue;

  return (
    <div className="select-container" ref={selectRef}>
      <button
        onClick={() => setOpen(!open)}
        className="select_btn">
        {selectIcon && <img src={selectIcon} />}
        <span>
          {label}- {displayLabel}
        </span>
        <ExpandLessIcon
          className={open ? '' : 'rotate-180'}
        />
      </button>
      {open && (
        <div className="options-overlay">
          <div className="options-wrapper">
            {options.map((option) => (
              <div
                onClick={() =>
                  handleOptionSelection(option)
                }
                key={option.value}
                className={clsx(
                  'option',
                  option.value === selectedValue
                    ? 'option--selected'
                    : ''
                )}>
                {option.icon && (
                  <span className="col-span-4 flex justify-center pr-2">
                    {option.icon}
                  </span>
                )}
                <span className="option-label col-span-8">
                  {option.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
